import { css } from 'linaria';

export const button = css`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 167px;
`;
